import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_CommunityServicelog = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_CommunityServicelog' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Community Service Log</h3></p>
                <table>


                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>(1). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_1' name='txtClientNamePrint_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_1' name='txtApptDate_1' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_1' name='txtApptTime_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_1' name='txtClinicianArrivalTime_1' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_1' name='txtClinicianName_1' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_1' name='txtClientNameSign_1' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(2). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_2' name='txtClientNamePrint_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_2' name='txtApptDate_2' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_2' name='txtApptTime_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_2' name='txtClinicianArrivalTime_2' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_2' name='txtClinicianName_2' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_2' name='txtClientNameSign_2' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(3). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_3' name='txtClientNamePrint_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_3' name='txtApptDate_3' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_3' name='txtApptTime_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_3' name='txtClinicianArrivalTime_3' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_3' name='txtClinicianName_3' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_3' name='txtClientNameSign_3' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(4). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_4' name='txtClientNamePrint_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_4' name='txtApptDate_4' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_4' name='txtApptTime_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_4' name='txtClinicianArrivalTime_4' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_4' name='txtClinicianName_4' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_4' name='txtClientNameSign_4' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(5). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_5' name='txtClientNamePrint_5' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_5' name='txtApptDate_5' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_5' name='txtApptTime_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_5' name='txtClinicianArrivalTime_5' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_5' name='txtClinicianName_5' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_5' name='txtClientNameSign_5' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(6). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_6' name='txtClientNamePrint_6' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_6' name='txtApptDate_6' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_6' name='txtApptTime_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_6' name='txtClinicianArrivalTime_6' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_6' name='txtClinicianName_6' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_6' name='txtClientNameSign_6' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(7). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_7' name='txtClientNamePrint_7' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_7' name='txtApptDate_7' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_7' name='txtApptTime_7' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_7' name='txtClinicianArrivalTime_7' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_7' name='txtClinicianName_7' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_7' name='txtClientNameSign_7' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(8). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_8' name='txtClientNamePrint_8' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_8' name='txtApptDate_8' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_8' name='txtApptTime_8' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_8' name='txtClinicianArrivalTime_8' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_8' name='txtClinicianName_8' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_8' name='txtClientNameSign_8' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(9). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_9' name='txtClientNamePrint_9' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_9' name='txtApptDate_9' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_9' name='txtApptTime_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_9' name='txtClinicianArrivalTime_9' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_9' name='txtClinicianName_9' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_9' name='txtClientNameSign_9' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(10). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_10' name='txtClientNamePrint_10' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_10' name='txtApptDate_10' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_10' name='txtApptTime_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_10' name='txtClinicianArrivalTime_10' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_10' name='txtClinicianName_10' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_10' name='txtClientNameSign_10' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(11). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_11' name='txtClientNamePrint_11' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_11' name='txtApptDate_11' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_11' name='txtApptTime_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_11' name='txtClinicianArrivalTime_11' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_11' name='txtClinicianName_11' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_11' name='txtClientNameSign_11' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(12). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_12' name='txtClientNamePrint_12' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_12' name='txtApptDate_12' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_12' name='txtApptTime_12' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_12' name='txtClinicianArrivalTime_12' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_12' name='txtClinicianName_12' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_12' name='txtClientNameSign_12' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(13). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_13' name='txtClientNamePrint_13' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_13' name='txtApptDate_13' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_13' name='txtApptTime_13' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_13' name='txtClinicianArrivalTime_13' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_13' name='txtClinicianName_13' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_13' name='txtClientNameSign_13' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(14). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_14' name='txtClientNamePrint_14' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_14' name='txtApptDate_14' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_14' name='txtApptTime_14' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_14' name='txtClinicianArrivalTime_14' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_14' name='txtClinicianName_14' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_14' name='txtClientNameSign_14' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-250'>
                             <span className='eleHeader'>(15). Client Name Print</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Appt. Date</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Appt. Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtClientNamePrint_15' name='txtClientNamePrint_15' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtApptDate_15' name='txtApptDate_15' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='time' id='txtApptTime_15' name='txtApptTime_15' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Arrival Time</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician Name</span></td>
                        <td className='w-230'>
                            <span className='eleHeader'>Client Name Sign</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtClinicianArrivalTime_15' name='txtClinicianArrivalTime_15' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtClinicianName_15' name='txtClinicianName_15' className='add-only' /></td>
                        <td className='w-230'>
                            <input type='text' id='txtClientNameSign_15' name='txtClientNameSign_15' className='add-only' /></td>
                    </tr>
                </table>






            </div>
        </form>

    )
}   